import React from "react";

const PageHeader = ({ title, subtitle, action }) => (
  <div className="page-header">
    <div className="page-header-row">
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  </div>
);

export default PageHeader;
